module.exports = __webpack_public_path__ + "assets/images/default-assignment.409c646bb78e6a3148aa7a569f1c702a.svg";